export class Constants {

  static readonly DalrC = 9.8;
  static readonly DalrF = 5.5;

  static readonly WEATHER_API_ENDPOINT = 'https://api.open-meteo.com/v1/forecast';
  static readonly BIG_DATA_API_ENDPOINT = 'https://api-bdc.net/data/reverse-geocode';
  static readonly BIG_DATA_API_KEY = 'bdc_365ca2d85de7446fab1003269c716cb5';
}
